"use strict";

class SalesApplicationAddSaleUnitSelectionController {

  constructor($scope, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSConfigService, SSAppService, SSUserService, SSAlertService, SSEoiService) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.$timeout = $timeout;
    self.$storage = $localStorage;

    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSConfigService = SSConfigService;
    self.SSAppService = SSAppService;
    self.SSUserService = SSUserService;
    self.SSAlertService = SSAlertService;
    self.SSEoiService = SSEoiService;

    self.PROPERTY_TYPE_PRIVATE_CONDO = 1;
    self.PROPERTY_TYPE_EXECUTIVE_CONDO = 2;
    self.PROPERTY_TYPE_LANDED = 3;
    self.PROPERTY_TYPE_APARTMENT = 4;
    self.PROPERTY_TYPE_INTERGATED_DEVELOPMENT = 5;
    self.PROPERTY_TYPE_COMMERCIAL = 6;

    self.UNIT_CATEGORIES_MAP = {
      0: {code: 'XX', name: 'Other', className: 'empty'},
      1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
      2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
      3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
      4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
      5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
      6: {code: 'PH', name: 'Penthouse', className: 'ph'},
      7: {code: 'COM', name: 'Commercial', className: 'retail'},
      1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
      2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
      3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
      4000: {code: 'DE', name: 'Detached', className: 'detached'},
      4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
      4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
    };

    // UNIT_STATUS_DRAFT = 10; // just created not listed
    // UNIT_STATUS_LISTED = 20; // listing and ready for sale to public
    // UNIT_STATUS_RESERVED = 30; // booknow session in-progress
    // UNIT_STATUS_BOOKED = 40; // dealing in process
    // UNIT_STATUS_SOLD = 50;
    // UNIT_STATUS_SPECIAL_RESERVED = 60;// Long time reserved

    self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
    self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
    self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
    self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
    self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
    self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

    // Broker roles in a sale
    self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;  // 1
    self.BROKER_ROLE_CO_BROKER = SHOWSUITE.BROKER_ROLE_CO_BROKER;  // 2
    self.BROKER_ROLE_TAGGER = SHOWSUITE.BROKER_ROLE_TAGGER;  // 3

    /**
     * Eoi status
    */
    self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
    self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
    self.EOI_STATUS_VERIFIED = SHOWSUITE.EOI_STATUS_VERIFIED;  
    self.EOI_STATUS_WITHDRAWN = SHOWSUITE.EOI_STATUS_WITHDRAWN; 
    self.EOI_STATUS_REJECTED = SHOWSUITE.EOI_STATUS_REJECTED;
    self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
    self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
    self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
    self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

    self.eoiId = SHOWSUITE.data.eoi_id;
    self.launch_id = SHOWSUITE.data.launch_id;
    self.add_buyer = SHOWSUITE.data.add_buyer;
    self.selectedStackId = null;

    self.init();
  }

  init(){
    const self = this;

    self.user = self.SSUserService.getUser();
    if (!self.user) {
      self.SSUserService.showLoginModal();
    }

    self.currentTab = 1;
    self.selectedUnits = [];
    self.eoiSelectedUnitsArr = [];
    self.eoiUnits = [];
    self._eoiUnits = {};

    $('.datepicker').datepicker({ dateFormat: "dd/mm/yy" });

    self.getPropertyList();
  }

  getPropertyList() {

      const self = this;
      self.propertyList = null;
      self.duplicateEoi = [];
      self.duplicateCheque = [];
      let url = 'sec/developer/properties';
      let param = {
        status: SHOWSUITE.PROPERTY_STATUS_LISTED,
        summary: true
      };

      loading(true);
      self.SSHttpService.getAPIRequest(url, param).then(function (response) {
          // loading(false);

          if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
          }

          self.propertyList = response.data;

          if (self.propertyList.properties.length > 0) {
              self.property_selected = self.propertyList.properties[0].named_id;
              self.getProperty();
          }
      });
  }

  getProperty() {
      const self = this;
      self.show_phases=false;
      self.selectedStackId = null;

      if (!self.property_selected)
          return;

      self.selectedUnits = [];
      self.property = null;
      let url = 'sec/developer/properties/' + self.property_selected;

      loading(true);
      self.SSHttpService.getAPIRequest(url).then(function (response) {
          // loading(false);

          if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
          }

          self.property = response.data.property;
          self.SSEoiService.property = self.property;
          self.next_otp_no = response.data.next_otp_no;
          self.next_commercial_otp_no = response.data.next_commercial_otp_no;
          self.named_id=self.property.named_id;
          self.stats = response.data.stats;
          self.typeMaps = response.data.type_map;
          self.unitTypes = response.data.unit_types;
          self.getUnits(self.property.id)
          self.getUnitStacks(self.property.id);

          // Get property discounts
          self.getPropertyDiscounts(self.property.id);
      });
  }

  getPropertyDiscounts(property_id) {
    const self = this;

    if(!property_id){
      return;
    }

    let url = 'properties/' + property_id + '/property-discounts';

    // loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      // loading(false);
      if (response instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      if(response.data.property_discounts){

        let property_discounts_list = [];
        let property_discount_names = {};

        // Prepare discount type and name values
        $.each(response.data.property_discounts, function(index, discount){
          if(!property_discount_names.hasOwnProperty(discount.type)){
            property_discount_names[discount.type] = [];
          }
          property_discount_names[discount.type].push({ id: discount.id, name: discount.name, discount: discount});
        });

        self.SSEoiService.property_discount_names = property_discount_names;
       
        if (response.data.property_discounts) {
          $.each(response.data.property_discounts, function(index, property_discount) {

            property_discount.type_name = self.SSConfigService.getDiscountTypeName(property_discount.type);

            let _property_discount = null;
            if(property_discounts_list && property_discounts_list.length > 0){
              _property_discount = property_discounts_list.find(x => x.type == property_discount.type);
            }
            if(!_property_discount){
              property_discounts_list.push(property_discount);
            }

            // if (property_discount.is_active) {
            //   let start_date = moment(property_discount.availability_start_date);
            //   let end_date = moment(property_discount.availability_end_date);
            //   let today_date = moment();

            //   if (end_date.isSameOrAfter(today_date, 'day') && today_date.isSameOrAfter(start_date, 'day')) {
            //     let _property_discount = null;
            //     if(property_discounts_list && property_discounts_list.length > 0){
            //       _property_discount = property_discounts_list.find(x => x.type == property_discount.type);
            //     }
            //     if(!_property_discount){
            //       property_discounts_list.push(property_discount);
            //     }
            //   }
            // }
            
          });
          
          self.SSEoiService.all_property_discounts = response.data.property_discounts;

        }

        self.SSEoiService.property_discounts = property_discounts_list;

      }
    });
  }

  getUnits(property_id){
    const self = this;

    let url = 'properties/' + property_id + '/units';
    let params = {
      offset: 0,
      limit: 9999, // get max limit
      include: 'stacks',
      send_total_count: true
    };
    // loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      // loading(false);
      if (response instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }
      self.unitsArr = response.data.property_units;
      for(var i = 0; i < self.unitsArr.length; i++){
        let unit = self.unitsArr[i];
        if(_.includes(self.eoiUnitsArr, unit.id)){
          self.eoiUnits.push(unit);
          self._eoiUnits[unit.id] = unit;
        }
      };

      self.eoiUnits.reverse();
    });
  }
  getUnitStacks(property_id) {
    const self = this;

    self.units = null;

    let url = 'properties/'+ property_id +'/stacks';
    let params = {

        'return_property' : true,
        'property_columns' : 'id,named_id,name,type,product_type,status,location,country,region',
        'return_stack' : true,
        'stack_columns' : 'id,named_id,name',
        'include_units' : true,
        'unit_columns' : 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url,params).then(function (response) {
        loading(false);

        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        self.SSEoiService.stacks = response.data.property_stacks;
        self.processServerData();
        self.getPropertyUnitTypes();

    });
  }

  processServerData() {
    const self = this;

    jQuery.each(self.SSEoiService.stacks, function (i, stack) {
      if(stack.units){
        stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
      }
      stack.availableUnits = self.filterAvailableUnits(stack.units);
    });

    // Select first stack by default
    self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.SSEoiService.stacks[0].id;
  }

  filterViewStack(className) {
    const self = this;

    self.selected_class_name = className;
    
    var buttons = $( "div.scroll" ).find( "button" );

    //Make all visible
    var invisible_buttons = $( "div.scroll" ).find( "button.greyout" );
    jQuery.each(invisible_buttons, function (i, button) {
        $(button).removeClass("greyout");
    });

    //Make all invisible other than className
    if(className) {
      jQuery.each(buttons, function (i, button) {
        if(!$(button).hasClass(className)) {
            $(button).addClass("greyout");
        }
      });
    }
  }

  getPropertyUnitTypes() {
    const self = this;

    self.propertyUnitCategories = [];

    jQuery.each(self.SSEoiService.stacks, function (i, stack) {
      jQuery.each(stack.units, function (j, unit) {
        let category = null;
        if (unit.category in self.UNIT_CATEGORIES_MAP) {
          category = self.UNIT_CATEGORIES_MAP[unit.category];
        } else {
          category = self.UNIT_CATEGORIES_MAP[0];
        }

        if (self.propertyUnitCategories.indexOf(category) == -1) {
          self.propertyUnitCategories.push(category);
        }
      });
    });
  }

  getUnitCellClass(unit) {
    const self = this;

    let cls = '';

    if (!unit.category) {
        cls = 'empty';
    } else if (unit.status == self.UNIT_STATUS_LISTED) {
      if (unit.category in self.UNIT_CATEGORIES_MAP) {
          cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
      } else {
          cls = self.UNIT_CATEGORIES_MAP[0].className;
      }
    } else if (unit.status == self.UNIT_STATUS_SOLD) {
        cls = 'sold';
    } else if (unit.status == self.UNIT_STATUS_DRAFT) {
        cls = 'draft';
        //cls = self.UNIT_CATEGORIES_MAP[3].className;
    } else {
        cls = 'reserved';
    }

    return cls;
  }

  filterAvailableUnits(units) {
    const self = this;

    let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED,self.UNIT_STATUS_DRAFT];
    let filtered = [];

    _.each(units, function (unit) {
      if (statuses.indexOf(unit.status) !== -1)
        filtered.push(unit);
    });

    if (self.sortBy) {
      filtered = _.sortBy(filtered, function (item) {
          return item[self.sortBy];
      })
    }

    return filtered;
  }

  toggle_Unit_selection(unit) {
    const self = this;
    
    unit.clickedclass = unit.clickedclass ? false : true;

    if (self.selectedUnits.length > 0 && unit.clickedclass) {
      self.SSAlertService.warning("Error", "You cannot add more than 1 unit in Sale.");
      return;
    }
    
    if (unit.clickedclass) {
      unit.selection = 'selected';
      self.addUnit(unit);
    } else {
      unit.selection = 'unselected';
      self.removeUnit(unit);
    }
  }

  addUnit(_unit){
    const self = this;

    let unit = self._eoiUnits[_unit.id];

    if(!unit){
      unit = _unit;
    }

    if(self.selectedUnits.length){

      let temp = self.selectedUnits;
      self.selectedUnits = [];
      unit["selected"] = true;
      self.selectedUnits.push(unit);

      jQuery.each(temp, function(index, elem){
        elem["selected"] = true;
        if(!self.selectedUnits.find(x => x.id == elem.id)){
          self.selectedUnits.push(elem);
        }
      });
    }
    else{
      unit["selected"] = true;
      self.selectedUnits.push(unit);
    }
    if(self.selectedUnits.length > 1){
      self.selectedUnits.reverse();
    }
  }

  removeUnit(_unit){
    const self = this;

    jQuery.each(self.selectedUnits, function(index, unit){
      if(unit && unit.id == _unit.id){
        unit["selected"] = false;
        unit.selection = 'unselected';
        self.selectedUnits.splice(index, 1);

        // Add this unit to eoiUnits to be available for selection
        if(!_.includes(self.eoiUnits, unit.id) && _.includes(self.eoiSelectedUnitsArr, unit.id)){
          self.eoiUnits.push(unit);
        }
      }
    });
  }

  isUnitRemovable(_unit){

    if(_unit.hasOwnProperty("unit_sale_status")){
      if(_unit.unit_sale_status == 10){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return true;
    }

  }

  getUnitNumber(unit){
    const self = this;

    if(unit.length < 1){
      return '-';
    }
    return self.SSUtilService.getFullUnitNumber1(unit, false);
  }
  
  switchTab(index){
    const self = this;

    self.currentTab = index;
  }

  onBookingProceed() {
    const self = this;

    if (self.SSEoiService.sale_obj) {
      self.SSEoiService.sale_obj['selected_units'] = self.selectedUnits;
    } else {
      self.SSEoiService.sale_obj = {
        'selected_units': self.selectedUnits
      };
    }

    self.otpError = {};

    self.showOtpInformationModal();

    let property = self.SSEoiService.property;
    property["questions"] = [];

    //Get property questions
    let url = 'sec/developer/properties/' + self.property_selected + '/questions';

    self.SSHttpService.getAPIRequest(url).then(function (response) {
        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        property["questions"] = response.data.property_questions.filter(item => item.is_active === 1);

        property["questions"] = _.sortBy(property["questions"], "order");

        $.each(property.questions, function (index, question) {
            if (question.type == SHOWSUITE.QUESTION_TYPE_SELECT || question.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX || question.type == SHOWSUITE.QUESTION_TYPE_RADIO) {
                question["formatted_choices"] = JSON.parse(question.choices);
            }
        });
    });

    self.getAgencies();
  }

  getAgencies() {
    const self = this;

    self.agencies = [];
    let url = 'sec/developer/agencies';
    let params = {
      property_id: self.SSEoiService.property.id,
      include: 'agencies'
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);

      if (response instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      if (response.data && response.data.property_agencies) {
        self.SSEoiService.agencies = response.data.agencies;

        self.$timeout(function() { 
          $("select.dashboard-select#agencies").niceSelect('update');
        });
      }
    });
  }

  showOtpInformationModal() {
      const self = this;

      self.hideModals();

      self.showOtpInformation = true;
      $('#addOtpInformationModal').modal('show');
      self.$timeout(function() { 
        $(".datepicker").datepicker( { dateFormat: "yy-mm-dd" } );
      });
  }

  hideModals() {
    const self = this;

    self.showOtpInformation = false;

    if ($('#addOtpInformationModal').is(':visible')) $('#addOtpInformationModal').modal('hide');
  }

  addOtpInformation() {
    const self = this;

    self.otpError = {};

    //Validation
    self.validateOtpNo();
    self.validateOtpDate();

    if (!jQuery.isEmptyObject(self.otpError)) {
        return;
    }

    self.hideModals();
    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_CO_BROKER_SELECTION_PAGE;
    self.SSAlertService.message = null
  }

  validateOtpNo() {
    const self = this;

    if (!!self.SSEoiService.sale_obj.otp_no) {

      let shortCode = self.SSEoiService.property.short_code;
      let shortCodeLength = shortCode ? shortCode.length : 0;
      let otpLength = shortCodeLength + 4;
      let commercial_settings = self.SSEoiService.property.settings.find(x => x.name == "different_otp_for_commercial_units");
      if (commercial_settings) {
        commercial_settings = JSON.parse(commercial_settings.value);
      }

      if (self.selectedUnits[0].category == SHOWSUITE.UNIT_CATEGORY_COMMERCIAL && commercial_settings && commercial_settings.enable) {
        let prefix = commercial_settings.prefix;
        let prefixLength = prefix ? prefix.length : 0;
        let postfix = commercial_settings.postfix;
        let postfixLength = postfix ? postfix.length : 0;
        otpLength = prefixLength + 4 + postfixLength;

        if (self.SSEoiService.sale_obj.otp_no.length !== otpLength
            || self.SSEoiService.sale_obj.otp_no.substring(0, prefixLength) !== prefix
            || !self.SSUtilService.isPositiveInteger(self.SSEoiService.sale_obj.otp_no.substring(prefixLength, 4))
            || self.SSEoiService.sale_obj.otp_no.substr(self.SSEoiService.sale_obj.otp_no.length - postfixLength) !== postfix) {
          self.otpError["otp_no"] = "Please enter a valid OTP No.";
        }
      } else {
        if (self.SSEoiService.sale_obj.otp_no.length !== otpLength
            || self.SSEoiService.sale_obj.otp_no.substring(0, shortCodeLength) !== shortCode
            || !self.SSUtilService.isPositiveInteger(self.SSEoiService.sale_obj.otp_no.substring(shortCodeLength))) {
          self.otpError["otp_no"] = "Please enter a valid OTP No.";
        }
      }
    } else {
        self.otpError["otp_no"] = "Please enter OTP No.";
    }
  }

  validateOtpDate() {
    const self = this;

    if (!!self.SSEoiService.sale_obj.otp_date) {
      let today_date = moment();
      let otp_date = moment(self.SSEoiService.sale_obj.otp_date, "DD/MM/YYYY");

      if (otp_date.isAfter(today_date, 'day')) {
        self.otpError["otp_date"] = "OTP date must not be after today's date.";
      }
    } else {
        self.otpError["otp_date"] = "Please enter OTP Date.";
    }
  }
}

SalesApplicationAddSaleUnitSelectionController.$inject = ['$scope', '$window', '$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSEoiService'];
app.controller('SalesApplicationAddSaleUnitSelectionController', SalesApplicationAddSaleUnitSelectionController);